/**
 * Styles do modulo Suprimentos (Fase 7).
 * Reusa primitives de Orcamentos/styles + adiciona helpers proprios.
 */
import styled from "styled-components";

import { mq } from "../../styles/canonical/breakpoints";

export {
  Block,
  Card,
  DangerButton,
  EmptyMsg,
  ErrorMsg,
  Field,
  FieldLabel,
  FieldRow,
  FieldValue,
  Form,
  FormFooter,
  FormGrid,
  IconButton,
  InfoMsg,
  InlineHint,
  Input,
  Pill,
  PrimaryButton,
  SearchInput,
  SecondaryButton,
  SectionTitle,
  Select,
  Table,
  TableWrapper,
  Textarea,
  WarningMsg,
} from "../Orcamentos/styles";

export const SubNav = styled.nav`
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  padding: 8px 0;
  border-bottom: 1px solid ${({ theme }) => theme.border};
  margin-bottom: 12px;

  a {
    padding: 6px 12px;
    border-radius: 6px;
    text-decoration: none;
    color: ${({ theme }) => theme.textSecondary};
    font-size: 0.85rem;
    font-weight: 500;

    &:hover {
      background: ${({ theme }) => theme.surfaceAlt};
    }

    &.active {
      background: ${({ theme }) => theme.accent};
      color: var(--ink-on-accent);
    }
  }
`;

export const TruncCell = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`;

export const SubText = styled.span`
  display: block;
  font-size: 0.72rem;
  color: ${({ theme }) => theme.textSecondary};
  margin-top: 1px;
  @media ${mq.mobile} {
    font-size: var(--text-min);
  }
`;
